export function notEmpty<TValue>(
  value: TValue | null | undefined,
): value is TValue {
  if (value == null) return false;
  const _testDummy: TValue = value;
  return true;
}

export function notError<TValue>(result: TValue | Error): result is TValue {
  return !(result instanceof Error);
}
